export const FormatNoteHasModelList = (modelList) => {
  return modelList.map((model) => formatNoteHasModel(model));
};

export const formatNoteHasModel = (model) => {
  return {
    id: model?.id,
    model_id: model.model_id,
    name: `${model.first_name} ${model.last_name}`,
  };
};
